import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isFetching && !_ctx.isDeleting)
      ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
          key: 0,
          color: "primary",
          split: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.data && _ctx.data.length > 0 ? _ctx.fetchPDFs(_ctx.data, _ctx.field) : undefined))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.formLabel('downloadPDFs')) + " " + _toDisplayString(_ctx.data && _ctx.data.length > 0 ? _ctx.data.length : undefined), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_q_list, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.deletePDFs(_ctx.data, _ctx.field)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formLabel('deletePDFs')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isFetching || _ctx.isDeleting)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          flat: "",
          "no-caps": "",
          class: "text-primary",
          label: _ctx.isFetching ? 'Cancel Download' : 'Cancel Delete',
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.cancelFetch()), ["stop"]))
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_q_circular_progress, {
          key: 2,
          min: 0,
          max: _ctx.data ? _ctx.data.length : undefined,
          value: _ctx.fetchProgress,
          size: "20px",
          thickness: 0.22,
          color: _ctx.progressColor,
          indeterminate: _ctx.progressIndeterminate,
          "track-color": "grey-3",
          class: "q-ma-md"
        }, null, 8, ["max", "value", "color", "indeterminate"]))
      : _createCommentVNode("", true)
  ], 64))
}